import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { StagingArea } from "../models/response-models/staging-area";

@Injectable({
    providedIn: 'root'
  })
  export class StagingService {

    activeStagingArea: StagingArea;

    constructor(
        private http: HttpClient
      ) { }

      getStagingAreas(): Observable<StagingArea[]>{
        return this.http.get<StagingArea[]>(environment.serverUrl + "/staging/stagingArea");
      }

      getStagingAreasByID(stagingAreaID: string): Observable<StagingArea>{
        return this.http.get<StagingArea>(environment.serverUrl + "/staging/stagingArea/" + stagingAreaID);
      }

      getUpcomingStagingArea(): Observable<StagingArea> {
        return this.http.get<StagingArea>(environment.serverUrl + "/staging/stagingArea/upcomingStagingArea");
      }

      createStagingArea(data: StagingArea): Observable<StagingArea>{
        return this.http.post<StagingArea>(environment.serverUrl + "/staging/stagingArea", data);
      }

      editStagingArea(data: StagingArea): Observable<StagingArea>{
        return this.http.put<StagingArea>(environment.serverUrl + "/staging/stagingArea/" + data.id, data);
      }

      removeStagingAreaByID(stagingAreaID: string): Observable<StagingArea>{
        return this.http.delete<StagingArea>(environment.serverUrl + "/staging/stagingArea/" + stagingAreaID);
      }

      copyToStagingArea(stagingAreaID: string): Observable<any>{
        return this.http.post<any>(environment.serverUrl + "/staging/copyDataToStagingArea/" + stagingAreaID, null);
      }

      mergeDataToHub(stagingAreaID: string): Observable<any>{
        return this.http.post<any>(environment.serverUrl + "/staging/mergeDataToHub/" + stagingAreaID, null);
      }

      deleteStagingData(stagingAreaID: string): Observable<any>{
        return this.http.post<any>(environment.serverUrl + "/staging/deleteStagingData/" + stagingAreaID, null);
      }
  }
